import { showComponent } from '@trip-ux/common';
import React, { forwardRef, useRef, FC, FocusEventHandler, SyntheticEvent } from 'react';
import { time } from 'uniqid';

export type CheckboxProps = {
  children?: React.ReactNode;
  name: string;
  id?: string;
  ariaLabel?: string;
  disabled?: boolean;
  tabIndex?: number;
  onChange: (e: SyntheticEvent) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  className?: string;
  checked?: boolean;
  hasError?: boolean;
  isRequired?: boolean;
};
const voidFunc = () => true;
export const Checkbox: FC<CheckboxProps> = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      name,
      checked = false,
      id = time('checkbox-id-'),
      ariaLabel,
      disabled = false,
      onChange,
      onBlur = () => true,
      onFocus = () => true,
      className = '',
      hasError,
      isRequired,
      children,
      tabIndex,
    },
    ref
  ) => {
    const checkRef = useRef(null);
    const refDom = ref || checkRef;

    return (
      <div className={`checkbox ${className}`}>
        <span>
          <input
            name={name}
            ref={refDom}
            id={id}
            data-testid={id}
            checked={checked}
            aria-label={ariaLabel}
            disabled={disabled}
            type="checkbox"
            onBlur={onBlur}
            onFocus={onFocus}
            onClick={onChange}
            onChange={voidFunc}
            aria-invalid={hasError}
            aria-required={isRequired}
            className={hasError ? 'error' : null}
            aria-describedby={`${id}-described`}
            {...(tabIndex !== undefined ? { tabIndex } : {})}
          />
          {showComponent(
            checked,
            <div
              aria-hidden="true"
              data-testid={`${id}-checkmark`}
              className={`checkmark${disabled ? ' disabled' : ''}`}
            />
          )}
        </span>
        <label htmlFor={id} className={`checkbox-label ${disabled ? 'dis-clr disabled' : ''}`}>
          {children}
        </label>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
export default Checkbox;
